import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Error as FoundationError } from 'fl-foundation';
import { NewrelicService } from '../../../../analytics/newrelic/service/newrelic.service';
import { ErrorEvents } from '../../../models/ErrorEvents';
import { FireboltService } from '../../../services/firebolt.service';
import { openErrorDialog } from '../error-dialog/error-dialogs';
import { ErrorBase } from '../model/ErrorBase';
import { QPError } from '../model/QPError';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private zone: NgZone,
    private matDialog: MatDialog,
    private newrelic: NewrelicService,
    private fireboltService: FireboltService
  ) {}
  async handleError(error: Error | any | HttpErrorResponse): Promise<void> {
    let message;
    if (!error) {
      return;
    }
    console.error('Error from global error handler', error);
    const errorDefinition = this.getErrorDefinition(error);
    const flError = error.rejection ? this.checkIsFoundationError(error.rejection) : false;
    this.newrelic.sendError(errorDefinition, ErrorEvents.GENERAL_ERROR);
    if (errorDefinition instanceof HttpErrorResponse) {
      message = this.getServerErrorMessage(error);
      console.warn('[ERROR] Server', message);
      this.fireboltService.reportError(
        navigator.onLine ? 'network' : 'restriction',
        errorDefinition.status?.toString(),
        errorDefinition.message,
        false
      );
    } else if (errorDefinition instanceof QPError) {
      console.log('[ERROR] QPError', errorDefinition.message);
      this.fireboltService.reportError('other', errorDefinition.error.errorCode?.toString(), errorDefinition.message, false);
    } else if (errorDefinition instanceof ErrorBase) {
      console.log('[ERROR] QPError', errorDefinition.message);
      this.fireboltService.reportError('other', '0x0000', errorDefinition.message, false);
    } else if (flError) {
      console.log('isError from fl-foundation');
      // Handle FoundationError
      this.zone.run(() => {
        this.undefinedErrorHandlerDialog(error.rejection);
      });
    } else if (error.promise && error.rejection) {
      const errorDetails = error.rejection;
      console.log(error);
      if (errorDetails.errorCode) {
        console.log(errorDetails.errorMessage);
      } else {
        message = this.getClientErrorMessage(errorDefinition);
        console.log('Client error: ', message);
      }
    } else {
      message = this.getClientErrorMessage(errorDefinition);
      console.error(message);
    }
  }

  private checkIsFoundationError(error: any): error is FoundationError {
    return 'componentErrorCode' in error;
  }

  private async undefinedErrorHandlerDialog(error: FoundationError) {
    try {
      const errorCode = error?.errorCode;
      const errorMessage = error?.errorMessage;
      openErrorDialog(this.matDialog, errorCode?.toString(), errorMessage);
    } catch (e) {
      console.log('Error open error dialog');
      console.log(e);
    }
  }

  private getErrorDefinition(error: any): any {
    return error?.rejection ? error?.rejection : error;
  }

  private getClientErrorMessage(error: Error | any): string {
    return error.message ? error.message : error.toString();
  }

  private getServerErrorMessage(error: HttpErrorResponse): string {
    return navigator.onLine ? error.message : 'No Internet Connection';
  }
}
